import { rgba } from "polished";
import { breakpoints } from "./breakpoints";

const defaultColors = {
  primary: "#7049AE",
  secondary: "#654991",
  white: "#ffffff",
  dark: "#3A383F",
  black: "#000000",
  yellow: "#FDCE07",
  ash: "#3A383F",
  green: "#2DC86D",
  info: "#0e567c",
  primaryPurple: "#372063",
  accentPurple: "#B883F7",
  accentBlue: "#21B9DB",
  accentGreen: "#2DC86D",
  accentOrange: "#FF7052",
  accentYellow: "#FDCE07",
  accentBlack: "#231F20",
  greyBackground: "#F6F6F6"
};

const colors = {
  primary: defaultColors.primary,
  secondary: defaultColors.secondary,
  light: defaultColors.white,
  lightShade: rgba(defaultColors.white, 0.75),
  dark: defaultColors.dark,
  darkShade: rgba(defaultColors.dark, 0.75),
  ash: defaultColors.ash,
  bg: defaultColors.white,
  border: rgba(defaultColors.ash, 0.115),
  shadow: rgba(defaultColors.ash, 0.175),
  darkShadow: rgba(defaultColors.ash, 0.5),
  heading: defaultColors.dark,
  text: rgba(defaultColors.dark, 0.75),
  yellow: defaultColors.yellow,
  warning: defaultColors.yellow,
  success: defaultColors.green,
  info: defaultColors.info,
  primaryPurple: defaultColors.primaryPurple,
  accentPurple: defaultColors.accentPurple,
  accentBlue: defaultColors.accentBlue,
  accentGreen: defaultColors.accentGreen,
  accentOrange: defaultColors.accentOrange,
  accentYellow: defaultColors.accentYellow,
  accentBlack: defaultColors.accentBlack,
  greyBackground: defaultColors.greyBackground,

  modes: {
    dark: {
      primary: defaultColors.primary,
      secondary: defaultColors.secondary,
      light: defaultColors.white,
      lightShade: rgba(defaultColors.white, 0.75),
      dark: defaultColors.dark,
      darkShade: rgba(defaultColors.dark, 0.75),
      ash: defaultColors.ash,
      bg: defaultColors.dark,
      border: rgba(defaultColors.ash, 0.115),
      shadow: rgba(defaultColors.ash, 0.175),
      heading: defaultColors.white,
      text: rgba(defaultColors.white, 0.75),
      yellow: defaultColors.yellow,
      warning: defaultColors.yellow,
      success: defaultColors.green,
      info: defaultColors.info,
    },
  },
};

const theme = {
  initialColorModeName: "light",
  colors: colors,
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  breakpoints: [
    `${breakpoints.sm}px`,
    `${breakpoints.md}px`,
    `${breakpoints.lg}px`,
    `${breakpoints.xl}px`,
  ],
};

export default theme;
